var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 799.468,
    height: 552.327,
    viewBox: "0 0 799.468 552.327",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-560.266 -263.837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1352.3,232.384H580.059a13.747,13.747,0,0,0-13.613,13.848v524.66a13.74,13.74,0,0,0,13.613,13.819H1352.3a13.741,13.741,0,0,0,13.613-13.819V246.232a13.747,13.747,0,0,0-13.611-13.848Z",
    transform: "translate(-6.179 31.453)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.244,232.384h-748.6a13.225,13.225,0,0,0-13.2,13.223V746.614a13.219,13.219,0,0,0,13.2,13.2h748.6a13.219,13.219,0,0,0,13.2-13.2V245.608a13.224,13.224,0,0,0-13.193-13.223Z",
    transform: "translate(-4.945 34.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.315,232.511h-.005c-.84,0-1.518-.232-1.515-.516l.76-78.747c0-.284.683-.513,1.521-.513h.005c.84,0,1.518.232,1.515.516L511.836,232C511.833,232.281,511.153,232.511,510.315,232.511Z",
    transform: "translate(614.674 243.665)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.315,476.129h-.005c-.84,0-1.518-.3-1.515-.667l.76-99.066c0-.366.683-.663,1.521-.663h.005c.84,0,1.518.3,1.515.667l-.76,99.065C383.833,475.833,383.153,476.129,382.315,476.129Z",
    transform: "translate(548.032 183.844)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.315,250.062h-.005c-.84,0-1.518-.2-1.516-.442l.76-66.448c0-.242.683-.438,1.521-.439h.005c.84,0,1.518.2,1.515.442l-.76,66.448C288.833,249.866,288.153,250.062,287.315,250.062Z",
    transform: "translate(498.572 268.691)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.025,397.987c2.928-15.81,20.9-23.1,35.469-21.863,20.815,1.77,38.186,15.474,57.559,21.934,9.362,3.122,19.434,4.836,29.244,3.039a44.535,44.535,0,0,0,20.778-10.49c11.264-9.627,18.879-22.756,30.151-32.373a37.536,37.536,0,0,1,21.732-9.489c9.946-.661,19.686,2.71,28.4,7.228,17.319,8.975,31.5,23.256,49.944,30.183a51.08,51.08,0,0,0,26.616,2.75,69.3,69.3,0,0,0,25.019-10.384c15.883-10.034,28.972-23.958,45.672-32.758,8.212-4.327,17.335-7.637,26.716-7.7a35.4,35.4,0,0,1,24.35,9.749c12.648,11.5,22.62,29.646,41.937,29.965a20.96,20.96,0,0,0,11.419-3.134c2.492-1.541.2-5.489-2.3-3.939-7.874,4.869-17.357,1.8-24.533-2.926-7.643-5.029-13.069-12.716-19.307-19.265-6.2-6.506-13.427-11.986-22.341-14.016a48.592,48.592,0,0,0-26.618,2.224c-18.247,6.358-32.06,19.444-47.2,30.83-14.925,11.221-32.351,20.929-51.608,16.256-19.174-4.653-33.72-19.173-50.3-28.919-16.031-9.421-35.681-15.438-52.943-5.524-13.044,7.491-21.291,20.72-31.309,31.5-4.943,5.318-10.456,10.26-17.133,13.281-9.278,4.2-19.764,3.708-29.429,1.22-20.16-5.19-37.164-18.764-57.693-22.825-15.238-3.014-33.273.784-42.574,14.254a25.9,25.9,0,0,0-4.111,9.985c-.532,2.87,3.864,4.1,4.4,1.213Z",
    transform: "translate(476.074 181.895)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.768,
    cy: 19.768,
    rx: 19.768,
    ry: 19.768,
    transform: "translate(766.879 550.307)",
    fill: "#75C4C0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.768,
    cy: 19.768,
    rx: 19.768,
    ry: 19.768,
    transform: "translate(909.059 508.489)",
    fill: "#75C4C0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.768,
    cy: 19.768,
    rx: 19.768,
    ry: 19.768,
    transform: "translate(1103.7 494.803)",
    fill: "#75C4C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.229,228.88h-43.36a9.789,9.789,0,0,1-7.6-3.594,10.017,10.017,0,0,1-2.067-8.349,133.3,133.3,0,0,0,0-52.521,10.018,10.018,0,0,1,2.067-8.35,9.788,9.788,0,0,1,7.419-3.591c13.182-6.456,27.881-6.456,43.693,0a9.9,9.9,0,0,1,9.647,8.513,220.459,220.459,0,0,1,0,59.376A9.9,9.9,0,0,1,319.229,228.88Z",
    transform: "translate(488.266 202.183)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.18 18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M547.17,202.823h-43.36a9.906,9.906,0,0,1-9.8-8.515,220.47,220.47,0,0,1,0-59.377,9.906,9.906,0,0,1,9.634-8.514c13.643-6.115,28.334-6.114,43.676,0a9.791,9.791,0,0,1,7.45,3.593,10.017,10.017,0,0,1,2.067,8.349,133.3,133.3,0,0,0,0,52.521,10.016,10.016,0,0,1-2.067,8.349A9.789,9.789,0,0,1,547.17,202.823Z",
    transform: "translate(605.93 164.265)",
    fill: "#75C4C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.571,141.3h-36.5a2.281,2.281,0,0,1,0-4.562h36.5a2.281,2.281,0,1,1,0,4.562Z",
    transform: "translate(609.988 172.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.571,153.3h-36.5a2.281,2.281,0,0,1,0-4.562h36.5a2.281,2.281,0,0,1,0,4.562Z",
    transform: "translate(609.988 178.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.571,165.3h-36.5a2.281,2.281,0,0,1,0-4.562h36.5a2.281,2.281,0,1,1,0,4.562Z",
    transform: "translate(609.988 184.519)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.717,165.3h-36.5a2.281,2.281,0,1,1,0-4.562h36.5a2.281,2.281,0,1,1,0,4.562Z",
    transform: "translate(493.442 209.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.717,177.3h-36.5a2.281,2.281,0,1,1,0-4.562h36.5a2.281,2.281,0,0,1,0,4.562Z",
    transform: "translate(493.442 215.251)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.717,189.3h-36.5a2.281,2.281,0,1,1,0-4.562h36.5a2.281,2.281,0,0,1,0,4.562Z",
    transform: "translate(493.442 221.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.17,592.924h-43.36a9.906,9.906,0,0,1-9.8-8.515,220.462,220.462,0,0,1,0-59.376,9.906,9.906,0,0,1,9.6-8.515c14.119-7.582,28.834-7.584,43.742,0a9.787,9.787,0,0,1,7.413,3.592,10.016,10.016,0,0,1,2.067,8.349,133.311,133.311,0,0,0,0,52.523,10.016,10.016,0,0,1-2.067,8.349A9.789,9.789,0,0,1,416.17,592.924Z",
    transform: "translate(537.727 165.01)",
    fill: "#75C4C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.717,528.3h-36.5a2.281,2.281,0,1,1,0-4.562h36.5a2.281,2.281,0,1,1,0,4.562Z",
    transform: "translate(542.381 171.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.717,540.3h-36.5a2.281,2.281,0,0,1,0-4.562h36.5a2.281,2.281,0,0,1,0,4.562Z",
    transform: "translate(542.381 177.976)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.717,552.3h-36.5a2.281,2.281,0,1,1,0-4.562h36.5a2.281,2.281,0,1,1,0,4.562Z",
    transform: "translate(542.381 184.223)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1180.386 540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.23,242.795l12.1,5.734c-4.965-6.929-9.243-17.75-11.533-26.36-3.878,8.021-10.129,17.835-16.317,23.7l12.793-3.291c-7.883,38.635-37.533,66.371-71.487,66.371v2.942C581.256,311.887,612.181,282.989,620.23,242.795Z",
    transform: "translate(-545.791 -194.927)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.783,301.168h76.481c3.244,0,5.883,4.367,5.883,9.734s-2.639,9.734-5.883,9.734H541.783c-3.244,0-5.883-4.367-5.883-9.734S538.539,301.168,541.783,301.168Z",
    transform: "translate(-505.056 -301.168)",
    fill: "#75C4C0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-201.383 -174.318)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1300.276 808.773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.775,245.415,377.3,276.067a10.777,10.777,0,0,1-15.2-.891c-14.328-11.379-26.081-24.2-34.561-38.867a10.777,10.777,0,0,1,.891-15.2l34.471-30.652a10.777,10.777,0,0,1,15.2.891l34.561,38.867a10.777,10.777,0,0,1-.891,15.2Z",
    transform: "translate(-324.831 -187.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.775,245.415,377.3,276.067a10.777,10.777,0,0,1-15.2-.891c-16.346-10.008-28.593-22.519-34.561-38.867a10.777,10.777,0,0,1,.891-15.2l34.471-30.652a10.777,10.777,0,0,1,15.2.891l34.561,38.867a10.777,10.777,0,0,1-.891,15.2Zm-82.36-23.2a9.3,9.3,0,0,0-.77,13.121c7.645,15.508,19.432,28.288,34.561,38.867a9.3,9.3,0,0,0,13.121.769L410.8,244.316a9.3,9.3,0,0,0,.769-13.121l-34.561-38.867a9.3,9.3,0,0,0-13.121-.77Z",
    transform: "translate(-324.831 -187.744)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.287,209.4l-28.4,25.256a2.924,2.924,0,1,1-3.885-4.37l28.4-25.256a2.924,2.924,0,1,1,3.885,4.37Z",
    transform: "translate(-317.68 -179.954)",
    fill: "#75C4C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.6,217.618l-28.4,25.256a2.924,2.924,0,1,1-3.886-4.37l28.4-25.256a2.924,2.924,0,1,1,3.885,4.37Z",
    transform: "translate(-314.239 -176.084)",
    fill: "#75C4C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.978,201.178l-28.4,25.256a2.924,2.924,0,1,1-3.885-4.37l28.4-25.256a2.924,2.924,0,1,1,3.885,4.37Z",
    transform: "translate(-321.122 -183.824)",
    fill: "#75C4C0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(599.257 473.287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.069,311.743l6.905-4.454c-2.832,5.382-5.273,13.788-6.579,20.477-2.212-6.231-5.778-13.855-9.308-18.409l7.3,2.557c-4.5-30.012-21.411-51.558-40.78-51.558v-2.285C190.837,258.071,208.478,280.519,213.069,311.743Z",
    transform: "translate(-133.431 -238.048)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.6,355.915h76.481c3.244,0,5.883-4.227,5.883-9.422s-2.639-9.422-5.883-9.422H166.6c-3.244,0-5.883,4.227-5.883,9.422S163.354,355.915,166.6,355.915Z",
    transform: "translate(-147.872 -227.955)",
    fill: "#75C4C0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(598.463 408.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.162,273.04H265.29a10.777,10.777,0,0,0,10.765-10.765V210.265A10.777,10.777,0,0,0,265.29,199.5H219.162A10.777,10.777,0,0,0,208.4,210.265v52.011A10.777,10.777,0,0,0,219.162,273.04Z",
    transform: "translate(-204.715 -199.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.845,273.04h46.128a10.777,10.777,0,0,0,10.764-10.765V210.265A10.777,10.777,0,0,0,268.972,199.5H222.845a10.777,10.777,0,0,0-10.764,10.764c-5.169,16.364-4.644,33.8,0,52.011A10.777,10.777,0,0,0,222.845,273.04Zm46.128-72.069a9.3,9.3,0,0,1,9.294,9.294v52.011a9.3,9.3,0,0,1-9.294,9.294H222.845a9.3,9.3,0,0,1-9.294-9.294V210.265a9.3,9.3,0,0,1,9.294-9.294Z",
    transform: "translate(-208.398 -199.5)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,222.872h38.007a2.924,2.924,0,0,0,0-5.847H219a2.924,2.924,0,1,0,0,5.847Z",
    transform: "translate(-199.896 -191.25)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,233.872h38.007a2.924,2.924,0,0,0,0-5.847H219a2.924,2.924,0,1,0,0,5.847Z",
    transform: "translate(-199.896 -186.071)",
    fill: "#f2f2f2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.3f48b4854ed290b9279ad317d7505753.svg";
export { ForwardRef as ReactComponent };